import React from "react"
import PropTypes from "prop-types"

import LandingNavbar from "./navbar/landing-navbar"
import Footer from "./footer/footer"
import { Helmet } from "react-helmet";

import Favicon from '../images/favicon.png';


const Layout = ({ children }) => {

  return (
    <>
      <LandingNavbar/> 
      <Helmet>
        <link rel="shortcut icon" type="image/png" href={Favicon} />
        <meta name="google-site-verification" content="RTu1VYHRDI9aRr3RoMwBmgCStLwc-IJQfLVEsftqoPc" />
        <meta prefix="og: http://ogp.me/ns#" property="og:title"
          content="Maesh - PayNow payment gateway in Singapore 🇸🇬 | JS SDK WooCommerce Prestashop" />
        <meta prefix="og: http://ogp.me/ns#" property="og:url" content="https://maesh.io/" />
        <meta prefix="og: http://ogp.me/ns#" property="og:image" content="./images/Logo-Maesh.png" />
        <meta prefix="og: http://ogp.me/ns#" property="og:description" content="It's simply cheaper" />
        <link rel="sitemap" type="application/xml" title="Sitemap" href="/sitemap.xml"/>
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-110811143-5"></script>
        <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/6856311.js"></script>
				<script>
					{
						`
						var ffWidgetId = 'b78c7bc8-bee1-4588-8902-d8afa29a87a2';
						var ffWidgetScript  = document.createElement("script");
						ffWidgetScript.type = "text/javascript";
						ffWidgetScript.src = 'https://freddyfeedback.com/widget/freddyfeedback.js';
						document.head.appendChild(ffWidgetScript);
						`
					}
				</script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-110811143-5', {
                cookie_flags: 'max-age=7200;secure;samesite=none'
              });          
          `}
      	</script>

        <script>
          {`
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
          (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
          m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
          })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
          
          ga('create', 'UA-110811143-5', 'auto');
          ga('send', 'pageview');   
          `}
      	</script>
      </Helmet>   
      <main>{children}</main>
      <Footer/>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
